import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmbedConfigPanes  {
    _originalTypeClassName = "zERP.BO.EmbedConfigPanes";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmbedConfigPanes.translate = translateService;
}
this.filters = new Domain.EmbedConfigFilters();
this.EmbedConfigPanesKey = null;
this._key = this.EmbedConfigPanesKey = 0; 
}

static translate: TranslateService;
_key: any;
filters:any;
private _EmbedConfigPanesKey:any;
get EmbedConfigPanesKey(): any {
    return this._EmbedConfigPanesKey;
  }
set EmbedConfigPanesKey(value: any) {
    this._EmbedConfigPanesKey = value;
    this._key = value;
  }
static setfilters = ($this, value) => {
var oldValue = $this.filters;
$this.filters = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmbedConfigPanesKey == null || $this.EmbedConfigPanesKey == 0;
            }


}